import { getCardDisplayType } from '@/features/tmaisUsers/constants/rewardLedgerEntries.constant'
import { RewardLedgerEntryData } from '@/features/tmaisUsers/types/rewardLedgerEntries.type'
import { ComponentType } from 'react'
import { AcquiredTicketCard } from './AcquiredTicketCard'
import { CompletedMissionCard } from './CompletedMissionCard'
import { ConsumptionCard } from './ConsumptionCard'
import { RedeemedItemCard } from './RedeemedItemCard'

interface RedemptionHistoryCardProps {
  entry: RewardLedgerEntryData
}

const CARD_COMPONENT_MAP: Record<string, ComponentType<{ entry: RewardLedgerEntryData }>> = {
  redeemed_item: RedeemedItemCard,
  completed_mission: CompletedMissionCard,
  acquired_ticket: AcquiredTicketCard,
  consumption: ConsumptionCard,
  generic: RedeemedItemCard,
}

export const RedemptionHistoryCard = ({ entry }: RedemptionHistoryCardProps) => {
  const displayType = getCardDisplayType(entry)

  const CardComponent = CARD_COMPONENT_MAP[displayType]

  return <CardComponent entry={entry} />
}
